import axios from "axios";

export const createCause = async (username, causeVOToCreate) => {
    try {
        const {data} = await axios.post("/api/cause/create", {username, causeVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateCause = async (username, causeVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/cause/update", {username, causeVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}


export const viewCause = async (username, causeExternalReference) => {
    try {
        const {data} = await axios.post("/api/cause/view" , {username, causeExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}


export const viewCausesForProblem = async (username, problemExternalReference) => {
    try {
        const {data} = await axios.post("/api/cause/viewCausesForProblem" , {username, problemExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteCause = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/cause/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
